module.exports = __webpack_public_path__ + "img/1536299487.00934a85.jpg";